import { render, staticRenderFns } from "./ParteDiario.vue?vue&type=template&id=3bff2b5b&scoped=true&"
import script from "./ParteDiario.vue?vue&type=script&lang=js&"
export * from "./ParteDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff2b5b",
  null
  
)

export default component.exports